import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {CableInternal, CabosAlimentacaoInterno, MitraNetworkParameters} from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-central-office',
  templateUrl: './central-office.component.html',
  styleUrls: ['./central-office.component.scss']
})
export class CentralOfficeComponent implements OnInit {

  @Output() internalCablesChanged: EventEmitter<CabosAlimentacaoInterno> = new EventEmitter();

  @Input()
  parameters: MitraNetworkParameters;

  @Input()
  parentForm: FormGroup;

  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    const { central_office_settings } = this.parameters;

    this.form = this.formBuilder.group({
      internalCable: [central_office_settings?.internal_cable_type, Validators.required],
      maxLengthCable: [central_office_settings?.internal_cable_max_length, [Validators.required, Validators.min(0)]],
      connectionDgoInternalCable: [central_office_settings?.connector_dgo_internal_cable, Validators.required],
    });

    this.form.valueChanges.subscribe(v => {
      this.updateParameters();
    });

    this.parentForm.addControl('centralOffice', this.form);
  }

  private updateParameters(): void {
    const {value} = this.form;

    const shouldReload = (this.parameters.central_office_settings.connector_dgo_internal_cable !== value.connectionDgoInternalCable);

    this.parameters.central_office_settings = {
      internal_cable_type: value.internalCable,
      internal_cable_max_length: value.maxLengthCable,
      connector_dgo_internal_cable: value.connectionDgoInternalCable,
    };

    if (shouldReload) {
      if (value.connectionDgoInternalCable !== 'connectorized_cable') {
        this.parameters.internal_feeding_cables_types.forEach(type => {
          type.connector_type = 'NONE';
        });
      } else {
        this.parameters.internal_feeding_cables_types.forEach(type => {
          if (type.connector_type === 'NONE') {
            type.connector_type = null;
          }
        });
      }
    }

    if (shouldReload) {
      this.internalCablesChanged.emit(this.parameters.internal_feeding_cables_types);
    }
  }
}
